module.exports = __webpack_public_path__ + "static/media/action_delete.b7d49c5b.svg";


//////////////////
// WEBPACK FOOTER
// ./src/icons/action_delete.svg
// module id = 107
// module chunks = 0